import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { AgentV2ConversationsActions } from '@/agent-v2/conversations/store/slice'
import type { UserSkill } from '@/user-skills/schemas'

type SavedSkillEntry = { eventId: string; turnId: string; skillId: string; skillName: string }
type UserSkillChatState = {
  byConversationId: Record<string, SavedSkillEntry[] | undefined>
}
const initialState: UserSkillChatState = { byConversationId: {} }

const userSkillChatSlice = createSlice({
  name: 'userSkillChatState',
  initialState,
  reducers: {
    skillSaved: (state, action: PayloadAction<{ conversationId: string; eventId: string; turnId: string; skill: UserSkill }>) => {
      const { conversationId, eventId, turnId, skill } = action.payload
      const entries = (state.byConversationId[conversationId] ??= [])
      if (!entries.some((entry) => entry.eventId === eventId)) {
        entries.push({ eventId, turnId, skillId: skill.id, skillName: skill.name })
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AgentV2ConversationsActions.deleteConversation, (state, action) => {
        delete state.byConversationId[action.payload.conversationId]
      })
      .addCase(AgentV2ConversationsActions.nullifyData, () => initialState)
  },
})
export const UserSkillChatActions = userSkillChatSlice.actions
export default userSkillChatSlice.reducer
